import { Grid, Stack, Typography } from "@mui/material";
import { StandardCellList } from "../../../../components/Standards";
import React from "react";
import { useDispatchWrapper } from "../../../../hooks";
import { IStoreState } from "../../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { formatDate, formatTime } from "../../../../helpers";
import { PageLoader } from "../../../../components/PageLoader/PageLoader";
import { LoadState } from "../../../../constants/enums";
import { INewRemarket } from "../../../../redux/NewRemarket/NewRemarket.types";
import { fetchTaskNewRemarketAysnc } from "../../../../redux/NewRemarket/NewRemarketActions";
import { ITaskFileUploadAttachment } from "../../../../redux/tasks/task.types";
import { StandadCard } from "../../../../components/Cards";
import { FileUpload } from "../../../../components/FileUpload/FileUpload";

export const ViewNewUpload: React.FC<{
  taskCode: string;
  attachment: ITaskFileUploadAttachment[];
}> = (props) => {
  const { taskCode, attachment } = props;
  const { data, loading } = useSelector(
    (storeState: IStoreState) => storeState.NewRemarketChange.NewRemarket
  );

  const dispatch = useDispatchWrapper();
  const [taskDetails, setTaskDetails] = React.useState<INewRemarket>();

  React.useEffect(() => {
    dispatch(fetchTaskNewRemarketAysnc(taskCode));
  }, [taskCode]);

  React.useEffect(() => {
    if (data) {
      setTaskDetails(data);
    }
  }, [data]);

  return (
    <PageLoader loading={loading === LoadState.InProgress}>
      {taskDetails && (
        <Grid container spacing={1} sx={{ mt: 2 }}>
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Customer Information"
              colSize={3}
              list={[
                {
                  heading: "Policy Number",
                  data: {
                    type: "text",
                    value: taskDetails.policy_number,
                  },
                },
                {
                  heading: "Customer Code",
                  data: {
                    type: "text",
                    value: taskDetails.customer_code,
                  },
                },
                {
                  heading: "Customer Name",
                  data: {
                    type: "text",
                    value: taskDetails.customer_name,
                  },
                },
                {
                  heading: "Line of Business",
                  data: { type: "text", value: taskDetails.line_of_business },
                },

                {
                  heading: "Policy Type",
                  data: { type: "text", value: taskDetails.policy_type },
                },
                {
                  heading: "Branch",
                  data: {
                    type: "text",
                    value: taskDetails.branch,
                  },
                },
                {
                  heading: "Broker Code",
                  data: {
                    type: "text",
                    value: taskDetails.broker_code,
                  },
                },
                {
                  heading: "Insurer",
                  data: {
                    type: "text",
                    value: taskDetails.insurer,
                  },
                },
                {
                  heading: "Producer",
                  data: {
                    type: "text",
                    value: taskDetails.producer,
                  },
                },
                {
                  heading: "CSR",
                  data: {
                    type: "text",
                    value: taskDetails.csr,
                  },
                },
              ]}
            />
          </Grid>
          <Grid item xs={12} lg={12}>
            <StandardCellList
              heading="Coverage Change Information"
              colSize={3}
              list={[
                {
                  heading: "Effective Date",
                  data: {
                    type: "text",
                    value: formatDate(
                      taskDetails.effective_date_of_change || ""
                    ),
                  },
                },
                {
                  heading: "Effective Time",
                  data: {
                    type: "text",
                    value: formatTime(
                      taskDetails.effective_time_of_change || ""
                    ),
                  },
                },
                {
                  heading: "Details",
                  data: {
                    type: "text",
                    value: taskDetails.details,
                  },
                },
              ]}
            />
          </Grid>
        </Grid>
      )}
      <StandadCard sx={{ mt: 2 }}>
        <Typography
          variant="h2"
          fontWeight={600}
          color="primary"
          marginBottom={2}
        >
          {"Attachments"}
        </Typography>
        {attachment.length > 0 ? (
          attachment.map((item) => {
            return (
              <Stack
                key={item.key}
                direction={"row"}
                justifyContent={"center"}
                gap={4}
                alignItems={"center"}
              >
                <Typography variant="h4" fontWeight={"bold"}>
                  {" "}
                  {item.fileName}{" "}
                </Typography>
                <FileUpload value={item.url} />
              </Stack>
            );
          })
        ) : (
          <Typography variant="body1">No attachments</Typography>
        )}
      </StandadCard>
    </PageLoader>
  );
};
